import { Button } from '@/components/ui/button'
import { PageLayout } from '@/components/common/PageLayout'
import { AssessmentList } from '../features/dashboard/AssessmentList.js'
import { useAssessments } from '../features/dashboard/useAssessments.js'
import { canEditAssessment } from '../features/auth/permissions.js'
import { useSession } from '../features/auth/SessionContext.js'

/** The Manage Assessments page — the app's landing page. */
export function HomePage() {
  const { session } = useSession()
  const { data, loading, error, reload } = useAssessments()

  return (
    <PageLayout title="Manage Assessments">
      {loading ? (
        <p className="text-sm text-subtle">Loading assessments…</p>
      ) : error ? (
        <div className="flex flex-wrap items-center gap-4">
          <p className="text-sm text-danger">Couldn’t load your assessments. Please try again.</p>
          <Button variant="primaryOutline" size="sm" onClick={reload}>
            Retry
          </Button>
        </div>
      ) : (
        <AssessmentList items={data ?? []} canEdit={canEditAssessment(session?.user.roles)} />
      )}
    </PageLayout>
  )
}
